/**
 * Mixin for handling PitchYou button configuration
 * 
 * Usage:
 * 1. Import the mixin: import { pitchYouButtonMixin } from "../../utils/mixins/pitchYouButtonMixin.js";
 * 2. Add to component: mixins: [pitchYouButtonMixin],
 * 3. Use the pitchYouButton computed property in your template
 * 4. Requires a module prop with config.pitchYouButton
 */

export const pitchYouButtonMixin = {
  computed: {
    pitchYouButton() {
      if (this.module && this.module.config && this.module.config.pitchYouButton) {
        let button = this.module.config.pitchYouButton;

        // Apply default WhatsApp styling if custom colors are not enabled
        if (!this.module.config.pitchYouButton.useCustomColor) {
          button.backgroundColor = {
            label: "WA Green",
            value: "#25D366",
          };
          button.textColor = {
            label: "White",
            value: "#ffffff",
          };
        }

        return button;
      }

      return null;
    },
  },
};
